import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {
  Colors,
  Icon,
  Card,
  NonIdealState,
  NonIdealStateIconSize,
} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';

import {IState} from '../../shared/store/reducers';
import {ApiStatus, Favorite} from '../../shared/models';
import FavoriteItem from './FavoriteItem';

const FavoriteList = () => {
  const favorites = useSelector((state: IState) => state.favorite.results);
  const loadingStatus = useSelector(
    (state: IState) => state.favorite.loadingStatus
  );

  useEffect(() => {
    return () => {
      // dispatch(unsetWorkflows()); TODO - add unset
    };
  }, []);

  const noFavorites = favorites?.length === 0 || false;

  return (
    <div className="home__content__block">
      <div className="home__content__block__header">
        <Icon
          icon={IconNames.STAR}
          size={18}
          color={Colors.GOLD4}
          className="home__content__block__header__icon"
        />
        Favorites
      </div>

      {loadingStatus === ApiStatus.LOADING ? (
        <div className="home__content__favlist">
          <Card className="home__content__favlist__card bp4-skeleton" />
        </div>
      ) : noFavorites ? (
        <div className="home__content__favlist">
          <Card>
            <NonIdealState
              className="home__content__favlist__empty"
              icon={IconNames.STAR_EMPTY}
              iconSize={NonIdealStateIconSize.SMALL}
              title="No Favorites Yet"
              description="Click the star icon on a report to add it to your favorites"
              layout="horizontal"
            />
          </Card>
        </div>
      ) : (
        <div className="home__content__favlist">
          {favorites.map((favorite: Favorite) => {
            if (!favorite.item) {
              return null;
            }

            return <FavoriteItem
              key={favorite.item.uid}
              uid={favorite.item.uid}
              name={favorite.item.name}
              folderId={favorite.item.folder_id}
              type={favorite.item.type as any}
              thumbnail={favorite.item.thumbnail}
            />
          })
          }
        </div>
      )}
    </div>
  );
};

export default FavoriteList;
